import React, { createContext, ReactNode, useEffect, useState } from 'react';
import translations, { Language } from '../../translations';

interface LanguageContextProps {
  language: string;
  t: (key: string) => string;
  setLanguage: (lang: Language) => void;
}

export const LanguageContext = createContext<LanguageContextProps>({
  language: 'en',
  t: (key) => translations.get('en', key),
  setLanguage: () => {},
});

interface LanguageProviderProps {
  children: ReactNode;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const [language, setLanguage] = useState<Language>('en');

  useEffect(() => {
    document.documentElement.lang = language;
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute('content', translations.get(language, 'description'));
  }, [language]);

  const t = (key: string) => translations.get(language, key) || key;

  return (
    <LanguageContext.Provider value={{ language, t, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
